export const FINANCE_SALARY_COMPANIES_UPDATED_EVENT = "finance-salary-companies-updated";
